export default __webpack_public_path__ + "static/media/37k.9ece0c38.md";